import { render, staticRenderFns } from "./footerchannel.vue?vue&type=template&id=a29ee4a2&scoped=true&"
import script from "./footerchannel.vue?vue&type=script&lang=js&"
export * from "./footerchannel.vue?vue&type=script&lang=js&"
import style0 from "./footerchannel.vue?vue&type=style&index=0&id=a29ee4a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29ee4a2",
  null
  
)

export default component.exports